import { FC } from 'react';
import { Button, FieldRow, Flex, WrappedMutation } from '../../../../../components/shared';
import { DELETE_FILE } from '../../../../../graphql';

type Props = {
  file?: any;
  sessionId?: string;
  onDone: () => void;
  onDelete: () => void;
  refetchQueryFunction?: Function;
};

const FileForm: FC<Props> = props => (
  <WrappedMutation
    mutation={DELETE_FILE}
    awaitRefetchQueries={true}
    refetchQueries={() => props.refetchQueryFunction && props.refetchQueryFunction()}
    onCompleted={() => props.onDone()}
  >
    {(deleteFile, { loading }) => (
      <FieldRow justifyContent="flex-end">
        <Flex direction="row" size="1" justify="flex-end">
          <Flex direction="row" size="0.5" flexWrap="nowrap">
            <Button type="button" text="Cancel" mr={3} ml={3} onClick={() => props.onDone()} disabled={loading} />
            <Button
              bg="warning"
              type="button"
              p={0}
              mr={3}
              width="40px"
              text="View File"
              isLoading={loading}
              disabled={loading}
              onClick={() => window.open(props.file.url)}
            />
            <Button
              bg="error"
              type="button"
              p={0}
              width="40px"
              text="Delete"
              isLoading={loading}
              disabled={loading}
              onClick={() => {
                deleteFile({ variables: { id: props.file.id } });
                props.onDelete();
              }}
            />
          </Flex>
        </Flex>
      </FieldRow>
    )}
  </WrappedMutation>
);

export default FileForm;
